module.exports = __webpack_public_path__ + "img/moneymex_googleplay.e7c03b1e.webp";